<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{this.$t('base.gauge_point')}}</h4>
        </div>
        <div class="card-body">
          <!-- 表头 -->
          <div class="row table-head">
            <div class="col-1">
              <label class="form-label">{{this.$t('page.work-order.device.name')}}</label>
            </div>
            <div class="col-2">
              <label class="form-label">{{this.$t('page.gauge_point.alias')}}</label>
            </div>
            <div class="col-2"></div>
            <div class="col-1">
              <span class="must-input">* </span>
              <label class="form-label">{{this.$t('page.gauge_point.runnable_low')}}</label>
            </div>
            <div class="col-1">
              <span class="must-input">* </span>
              <label class="form-label">{{this.$t('page.gauge_point.ideal_low')}}</label>
            </div>
            <div class="col-1">
              <span class="must-input">* </span>
              <label class="form-label">{{this.$t('page.gauge_point.ideal_high')}}</label>
            </div>
            <div class="col-1">
              <span class="must-input">* </span>
              <label class="form-label">{{this.$t('page.gauge_point.runnable_high')}}</label>
            </div>
            <div class="col-1">
              <span class="must-input">* </span>
              <label class="form-label">{{this.$t('page.work-order.device.unit')}}</label>
            </div>
            <div class="col-1">
              <span class="must-input">* </span>
              <label class="form-label">{{this.$t('base.data_type')}}</label>
            </div>
            <div class="col-1">
              <label class="form-label">{{this.$t('page.gauge_point.show_or_not')}}</label>
            </div>
          </div>
          <!-- 表单内容 -->
          <div class="table-content" v-if="measureData.length">
            <div
              class="row table-content-row align-items-center"
              v-for="(measure, index) in measureData"
              :key="index"
            >
              <!-- 名称value -->
              <div v-if="(measure.owner != 'self')" class="col-1 d-flex align-items-center">
                <div>{{ measure.name }}</div>

                <el-tooltip v-if="measure.name == '电流'" placement="bottom">
                  <template #content> 提示：测点是默认电流，<br />用于运行状态及运行时<br />长判断。 </template>
                  <div><i class="ri-question-line cursor-pointer fs-15 ms-1"></i></div> 
                </el-tooltip>
              </div>
              <div v-else class="col-1">
                <input
                  type="text"
                  :class="['form-control']"
                  maxlength="50"
                  v-model="measure.name"
                  @input="changeMeasureName(measure)"
                />
              </div>
              <!-- 别名value -->
              <div class="col-2">
                <!-- 别名 -->
                <input
                  type="text"
                  :class="[
                    'form-control',
                    measure.alias &&
                      measure.dataValidation &&
                      measure.dataValidation.type &&
                      'is-invalid',
                  ]"
                  maxlength="50"
                  v-model="measure.alias"
                />
                <div
                  class="must-input position-absolute"
                  v-show="measure.alias && measure.alias.length >= 50"
                >
                  {{ error }}
                </div>
                <div
                  class="must-input position-absolute"
                  v-show="
                    measure.alias &&
                    measure.dataValidation &&
                    measure.dataValidation.type
                  "
                >
                  {{
                    measure.dataValidation && measure.dataValidation.typeError
                  }}
                </div>
              </div>
              <!-- 阀值范围 -->
              <div class="col-2">
                <div class="d-flex align-items-center justify-content-center">
                  <div class="form-switch form-switch-right form-switch-md">
                    <input
                      class="form-check-input code-switcher"
                      type="checkbox"
                      v-model="measure.recordThreshold"
                    />
                  </div>
                  <div>
                    <div v-show="measure.recordThreshold" class="ms-4">
                      {{this.$t('page.gauge_point.enter_threshold_range')}}
                    </div>
                    <div v-show="!measure.recordThreshold" class="ms-3">
                      {{this.$t('page.gauge_point.threshold_range_is_not_entered')}}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 可运行（低）value -->
              <div class="col-1">
                <form>
                  <input
                    v-if="measure.recordThreshold"
                    type="text"
                    :class="[
                      'form-control',
                      (measure.operationThresholdLow &&
                        measure.operationThresholdLow.length >= 50) ||
                      (measure.meatype &&
                        isCheckForm &&
                        measure.operationThresholdLow.length == 0)
                        ? 'is-invalid'
                        : '',
                    ]"
                    maxlength="50"
                    v-model="measure.operationThresholdLow"
                    required
                  />
                  <input
                    v-if="!measure.recordThreshold"
                    type="text"
                    class="form-control"
                    maxlength="50"
                    :value="this.$t('page.gauge_point.unrecordable')"
                    disabled
                  />
                  <div
                    class="must-input position-absolute"
                    v-show="
                      measure.meatype &&
                      measure.recordThreshold &&
                      (measure.operationThresholdLow.length >= 50 ||
                        (isCheckForm &&
                          measure.operationThresholdLow.length == 0))
                    "
                  >
                    {{
                      measure.operationThresholdLow.length >= 50
                        ? error
                        : this.$t('page.gauge_point.runnable_low_cannot_be_null')
                    }}
                  </div>
                </form>
              </div>
              <!-- 理想（低）value -->
              <div class="col-1">
                <form>
                  <input
                    v-if="measure.recordThreshold"
                    type="text"
                    :class="[
                      'form-control',
                      (measure.standardThresholdLow &&
                        measure.standardThresholdLow.length >= 50) ||
                      (measure.meatype &&
                        isCheckForm &&
                        measure.standardThresholdLow.length == 0)
                        ? 'is-invalid'
                        : '',
                    ]"
                    maxlength="50"
                    v-model="measure.standardThresholdLow"
                    required
                  />
                  <input
                    v-if="!measure.recordThreshold"
                    type="text"
                    class="form-control"
                    maxlength="50"
                    :value="this.$t('page.gauge_point.unrecordable')"
                    disabled
                  />
                  <div
                    class="must-input position-absolute"
                    v-show="
                      measure.meatype &&
                      measure.recordThreshold &&
                      (measure.standardThresholdLow.length >= 50 ||
                        (isCheckForm &&
                          measure.standardThresholdLow.length == 0))
                    "
                  >
                    {{
                      measure.standardThresholdLow.length >= 50
                        ? error
                        : this.$t('page.gauge_point.ideal_low_cannot_be_null')
                    }}
                  </div>
                </form>
              </div>
              <!-- 理想（高) value -->
              <div class="col-1">
                <form>
                  <input
                    v-if="measure.recordThreshold"
                    type="text"
                    :class="[
                      'form-control',
                      (measure.standardThresholdHigh &&
                        measure.standardThresholdHigh.length >= 50) ||
                      (measure.meatype &&
                        isCheckForm &&
                        measure.standardThresholdHigh.length == 0)
                        ? 'is-invalid'
                        : '',
                    ]"
                    maxlength="50"
                    v-model="measure.standardThresholdHigh"
                    required
                  />
                  <input
                    v-if="!measure.recordThreshold"
                    type="text"
                    class="form-control"
                    maxlength="50"
                    :value="this.$t('page.gauge_point.unrecordable')"
                    disabled
                  />
                  <div
                    class="must-input position-absolute"
                    v-show="
                      measure.meatype &&
                      measure.recordThreshold &&
                      (measure.standardThresholdHigh.length >= 50 ||
                        (isCheckForm &&
                          measure.standardThresholdHigh.length == 0))
                    "
                  >
                    {{
                      measure.standardThresholdHigh.length >= 50
                        ? error
                        : this.$t('page.gauge_point.ideal_high_cannot_be_null')
                    }}
                  </div>
                </form>
              </div>
              <!-- 可运行（高value -->
              <div class="col-1">
                <form>
                  <input
                    v-if="measure.recordThreshold"
                    type="text"
                    :class="[
                      'form-control',
                      (measure.operationThresholdHigh &&
                        measure.operationThresholdHigh.length >= 50) ||
                      (measure.meatype &&
                        isCheckForm &&
                        measure.operationThresholdHigh.length == 0)
                        ? 'is-invalid'
                        : '',
                    ]"
                    maxlength="50"
                    v-model="measure.operationThresholdHigh"
                    required
                  />
                  <input
                    v-if="!measure.recordThreshold"
                    type="text"
                    class="form-control"
                    maxlength="50"
                    :value="this.$t('page.gauge_point.unrecordable')"
                    disabled
                  />
                  <div
                    class="must-input position-absolute"
                    v-show="
                      measure.meatype &&
                      measure.recordThreshold &&
                      (measure.operationThresholdHigh.length >= 50 ||
                        (isCheckForm &&
                          measure.operationThresholdHigh.length == 0))
                    "
                  >
                    {{
                      measure.operationThresholdHigh.length >= 50
                        ? error
                        : this.$t('page.gauge_point.runnable_high_cannot_be_null')
                    }}
                  </div>
                </form>
              </div>
              <!-- 单位value -->
              <div v-if="(measure.owner != 'self')" class="col-1">
                {{ measure.unit }}
              </div>
              <div v-else class="col-1">
                <input
                  style="width: 100px"
                  type="text"
                  :class="['form-control']"
                  maxlength="50"
                  v-model="measure.unit"
                />
              </div>
              <!-- 数据类型 -->
              <div class="col-1">
                <Multiselect
                  :class="[submitted&&!measure.dtype && 'is-invalid']"
                  v-model="measure.dtype"
                  :close-on-select="true"
                  :searchable="false"
                  :canClear="false"
                  :options="dataTypes"
                  :disabled="(measure.owner != 'self')"
                />
              </div>
              <!-- 是否展示 -->
              <div class="col-1">
                  <div class="form-check mb-2">
                    <input v-model="measure.is_show" class="form-check-input" type="checkbox" id="formCheck1">
                  </div>
              </div>
              <!-- 删除 -->
              <div
                v-if="measure.owner == 'self'"
                style="position: absolute; right: 0; width: 72px"
              >
                <b-button
                  variant="primary"
                  size="sm"
                  :style="{
                    minWidth: '2.5rem',
                    marginTop: ' 0.34rem',
                    opacity: measure.disabled ? 0 : 1,
                  }"
                  :disabled="measure.disabled"
                  @click="tagMessageBox = index"
                  >{{this.$t('base.delete')}}</b-button
                >
                <MessageBox
                  v-if="tagMessageBox == index"
                  :messageCont="this.$t('page.deleteConfirm')"
                  :messageIcon="'ri-error-warning-line'"
                  :iconStyle="{ fontSize: '14px', color: '#f06548' }"
                  :messageStyle="{ top: '-6rem', left: '-3.5rem' }"
                  @makeSure="handleDelete(index)"
                  @makeClose="tagMessageBox = null"
                ></MessageBox>
              </div>
            </div>
          </div>
          <!-- 点击添加关联物实例 -->
          <div class="addButton">
            <b-button variant="primary" @click="addMeasureData()">
              {{this.$t('page.gauge_point.add')}}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessageBox from "@/components/common/MessageBox.vue";
import { dataTypes } from "@/utils/selectText.js";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { v4 as uuidv4 } from "uuid";
import {errorMsg} from "@/helpers/swal";
export default {
  data() {
    return {
      dataTypes: dataTypes,
      measureData: null,
      error: this.$t('page.character_length_cannot_exceed_50'),
      tagMessageBox: null,
      submitted:null,
    };
  },
  emits: ["update:measureDataList"],
  props: {
    measureDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isCheckForm: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    measureDataList: {
      handler(val) {
        this.measureData = val;
      },
      deep: true,
      immediate: true,
    },
    measureData: {
      handler(val) {
        this.$emit("update:measureDataList", val);
      },
      deep: true,
    },
  },
  methods: {
    addMeasureData() {
      let defaultData = {
        id: uuidv4(),
        alias: "",
        dataValidation: { type: false, typeError: "别名重复" },
        distype: false,
        dtype: "",
        owner: "self",
        key: "measure" + new Date().getTime(),
        meatype: false,
        name: "",
        operationThresholdHigh: "",
        operationThresholdLow: "",
        recordThreshold: false,
        standardThresholdHigh: "",
        standardThresholdLow: "",
        unit: "",
        is_show:true
      };
      this.measureData.push({ ...defaultData });
    },
    /* 校验是否多次输入名为电流的测点 */ 
    changeMeasureName(event){
      let list = this.measureData.filter(item => item.name === '电流')

      if(list.length>1){
        errorMsg("电流测点不能重复！")
        event.name = ""
      }

    },
    handleDelete(i) {
      this.measureData.splice(i, 1);
      this.tagMessageBox = null;
    },
  },
  components: { MessageBox, Multiselect },
};
</script>

<style scoped lang="scss"></style>
